import aos from "aos";
import { onReady } from "../../utils/events/onReady";

export class Hero {
    data = {};
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} container - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;

        onReady(() => this.init(this.dom.container));
    }

    init() {
        aos.init();
    }
}
